import React, { useEffect, useRef, useState } from "react";
import { getSponsors } from "./../apiEndpoints";
import SponsorImage from "./SponsorImage";
import string from "../constants/string";
import banner from "../assets/banner.png";
import quote from "../assets/quote.png";
import party from "../assets/party.png";
import partyB from "../assets/partyB.png";
import partyC from "./../assets/GiridharAramane.jpg";
import marshal from "./../assets/marshal.jpeg";
import party1 from "../assets/party1.png";
import party2 from "../assets/party2.png";
import party3 from "../assets/party3.png";
import party4 from "../assets/party4.png";
import party5 from "../assets/party5.png";
import party6 from "../assets/party6.png";
import cparty1 from "../assets/Defence-Secretary-Rajesh-Kumar-Singh.jpg";
import profit1 from "../assets/profit1.png";
import profit2 from "../assets/profit2.png";
import profit3 from "../assets/profit3.png";
import profit4 from "../assets/profit4.png";
import profitmain from "../assets/profitmain.png";
import minute1 from "../assets/minute1.png";
import minute2 from "../assets/minute2.png";
import minute3 from "../assets/minute3.png";
import HWS from "../assets/HWS.png";
import HWS2 from "../assets/HWS2.jpg";
import minute4 from "../assets/minute4.png";
import CommonHome from "./CommonHome";
import common1 from "../assets/common1.png";
import common2 from "../assets/common2.png";
import common3 from "../assets/common3.png";
import obj from "../assets/objmain.png";
import Slider from "react-slick";
import scroll from "../assets/scrolltop.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AboutImgs } from "../assets/Aboutimg/Aboutimg";
import party7 from "../assets/party7.png";
import party8 from "../assets/party8.png";
import party9 from "../assets/party9.png";
import party10 from "../assets/party10.png";

const Home = () => {
  // Sponsore Section - Start
  const [sponsors, setSponsors] = useState({});
  const messageRef = useRef();
  const whoParticipateRef = useRef();
  const objectiveRef = useRef();
  const sponsorRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const response = await getSponsors();
        if (response.success) {
          setSponsors(response.data);
        }
      } catch (error) {
        console.error("Error fetching sponsors:", error);
      }
    };

    fetchSponsors();
  }, []);

  // useEffect(() => {
  //   const query = new URLSearchParams(location.search);
  //   const scrollTo = query.get("scrollTo");

  //   if (scrollTo === "message") {
  //     setTimeout(() => {
  //       if (messageRef.current) {
  //         messageRef.current.scrollIntoView({ behavior: "smooth" });
  //       }
  //     }, 100);
  //   }
  //   if (scrollTo === "whoparticipate") {
  //     setTimeout(() => {
  //       if (whoParticipateRef.current) {
  //         whoParticipateRef.current.scrollIntoView({ behavior: "smooth" });
  //       }
  //     }, 100);
  //   }
  //   if (scrollTo === "objective") {
  //     setTimeout(() => {
  //       if (objectiveRef.current) {
  //         objectiveRef.current.scrollIntoView({ behavior: "smooth" })
  //       }
  //     }, 100);
  //   }
  //   if (scrollTo === "sponsor") {
  //     setTimeout(() => {
  //       if (sponsorRef.current) {
  //         sponsorRef.current.scrollIntoView({ behavior: "smooth" })
  //       }
  //     }, 100);
  //   }
  // })
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const scrollTo = query.get("scrollTo");

    const scrollToSection = (ref) => {
      setTimeout(() => {
        if (ref.current) {
          console.log("Scrolling to:", ref.current); // Debugging line
          ref.current.scrollIntoView({ behavior: "smooth" });

          // Remove scrollTo parameter from the URL after scrolling
          query.delete("scrollTo");
          navigate({ search: query.toString() }, { replace: true });
        } else {
          console.log("Ref not found:", ref); // Debugging line
        }
      }, 100);
    };

    if (scrollTo === "message") {
      scrollToSection(messageRef);
    } else if (scrollTo === "whoparticipate") {
      console.log("clicled ");
      scrollToSection(whoParticipateRef);
    } else if (scrollTo === "objective") {
      scrollToSection(objectiveRef);
    } else if (scrollTo === "sponsor") {
      console.log("clicled sposerSection");
      scrollToSection(sponsorRef);
    }
  }, [location.search, navigate]);

  const handlePriceList = () => {
    // navigate('/pricelist?scrollTo=sponsor')
    Swal.fire({
      title: "The event is over",
      text: "",
      icon: "info",
      confirmButtonText: "OK",
      showCancelButton: false, // Disable the cancel button
      showDenyButton: false, // Disable the deny button
      customClass: {
        confirmButton: "swal-confirm-button", // Optional: Apply custom styles if needed
      },
    });
  };

  const renderSponsorSection = (category, subcategories) => {
    // Check if the subcategories have any content
    const hasSubcategoriesContent = subcategories.some(
      (subcategory) =>
        sponsors[category] &&
        sponsors[category][subcategory] &&
        sponsors[category][subcategory].length > 0,
    );

    // Check if there's content for categories without subcategories
    const hasCategoryContent =
      sponsors[category] &&
      sponsors[category][""] &&
      sponsors[category][""].length > 0;

    // If there's no content in both subcategories and the category itself, skip rendering
    if (!hasSubcategoriesContent && !hasCategoryContent) {
      return null;
    }

    return (
      <div
        className="px-8 py-10 rounded-[50px] border-[1px] border-iconborder/30 my-20"
        key={category}
      >
        <div className="relative font-EBGaramond flex justify-center my-8">
          <h2 className="uppercase text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl font-bold pb-[0.35rem] ">
            {category}
          </h2>
          <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
        </div>
        <div className="flex flex-col gap-12 justify-center px-4 lg:px-16">
          {subcategories.length > 0
            ? subcategories.map(
                (subcategory) =>
                  sponsors[category] &&
                  sponsors[category][subcategory] &&
                  sponsors[category][subcategory].length > 0 && (
                    <div
                      key={subcategory}
                      className="flex flex-col justify-center"
                    >
                      <div className="text-center text-textblue text-base sm:text-lg md:text-xl lg:text-xl xl:text-2xl py-4">
                        {subcategory}
                      </div>
                      <SponsorImage
                        sponsors={sponsors[category][subcategory]}
                      />
                    </div>
                  ),
              )
            : sponsors[category] &&
              sponsors[category][""] &&
              sponsors[category][""].length > 0 && (
                <SponsorImage sponsors={sponsors[category][""]} />
              )}
        </div>
      </div>
    );
  };

  // Sponsore Section - End

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow next-arrow`}
        style={{ ...style }}
        onClick={onClick}
      >
        <FaArrowRight className="text-white text-3xl" />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow prev-arrow`}
        style={{ ...style }}
        onClick={onClick}
      >
        <FaArrowLeft className="text-white text-3xl text-center" />
      </div>
    );
  };

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour 
               in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);
  return (
    <section className="font-poppins flex flex-col items-center justify-center overflow-x-hidden">
      <div className="container 3xl:w-[70%] px-4 lg:px-0 xl:px-20 py-12">
        <img src={HWS} alt="" className="w-full" />
      </div>
      <div className="text-center w-full bg-numbercolorhome ">
        <p className="text-white py-8 text-lg md:text-xl lg:text-2xl xl:text-3xl">
          {string.partyheadline}
        </p>
      </div>
      <div className="container 3xl:w-[70%] px-4 lg:px-8 xl:px-12 2xl:px-20 py-12 ">
        <div className="justify-between gap-6 flex md:flex-row flex-col lg:px-12 px-4 mb-12">
          <div className="image md:w-[36%] w-full px-4 md:px-0">
            <img src={AboutImgs.A8} alt="" className="w-full" />
          </div>
          <div className="para md:w-[64%] w-full">
            <p className="text-[0.875rem] leading-5 lg:text-[1rem] lg:leading-6 xl:text-[1.25rem] xl:leading-7 text-justify px-0 2xl:px-10">
              {string.partyparamain}
            </p>
          </div>
        </div>
        {/* message  */}
        <div
          id="message"
          ref={messageRef}
          className="flex flex-col justify-center overflow-hidden py-12 relative"
        >
          <Slider {...settings} className="">
            {/* First slide */}
            <div className="px-4 lg:px-8 h-[450px] md:h-[600px] lg:h-[500px] xl:h-[600px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partydesignationc1}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteC1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteD4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6 pb-4">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl"></div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: string.partyrolesc1,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center mb-20">
                  <img
                    src={cparty1}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>

            {/* Second slide */}
            <div className="px-4 lg:px-8 h-[300px] md:h-[500px] lg:h-[300px] xl:h-[500px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partydesignation1}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteA1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteA2}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteA3}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteA4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl">
                      {string.partyname1}
                    </div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{ __html: string.partyroles1 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center">
                  <img
                    src={party}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Third Slide - Secretary Defence Production */}
            <div className="px-4 lg:px-8 h-[450px] md:h-[600px] lg:h-[500px] xl:h-[600px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partydesignation4}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteD1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteD4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6 pb-4">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl"></div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{ __html: string.partyroles3 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center mb-20">
                  <img
                    src={party7}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Fourth Slide - Air Chief Marshal */}
            <div className="px-4 lg:px-8 h-[300px] md:h-[500px] lg:h-[300px] xl:h-[500px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partyAirStaff}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteE1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteE4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl"></div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{ __html: string.partyroles4 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center">
                  <img
                    src={party8}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Fifth Slide - Chief of Defence Staff */}
            <div className="px-4 lg:px-8 h-[450px] md:h-[600px] lg:h-[500px] xl:h-[600px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partyChiefDefenceStaff}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteF1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteF4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6 pb-4">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl"></div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{ __html: string.partyroles5 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center">
                  <img
                    src={party9}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Sixth Slide - Chief of the Army Staff */}
            <div className="px-4 lg:px-8 h-[450px] md:h-[600px] lg:h-[500px] xl:h-[600px] flex flex-col">
              <div className="headfing flex flex-col justify-center items-center min-h-[120px] flex-shrink-0">
                <div className="text-center text-textblue font-poppins text-base md:text-lg lg:text-2xl xl:text-4xl">
                  {string.partyquotemessage}{" "}
                  <span className="font-Bonheur-Royale">
                    {string.partyquotespan}
                  </span>
                </div>
                <div className="text-center font-EBGaramond uppercase text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                  {string.partyChiefArmyStaff}
                </div>
              </div>
              <div className="font-poppins flex justify-between gap-4 md:gap-8 flex-col-reverse md:flex-row flex-grow">
                <div className="w-full md:w-[65%] flex flex-col justify-between h-full">
                  <div className="flex-grow">
                    <img src={quote} alt="" className="md:scale-75 mb-4" />
                    <div className="space-y-4">
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteG1}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-justify">
                        {string.partyquoteG2}
                      </div>
                      <div className="text-sm md:text-[1rem] lg:text-base xl:text-xl text-end">
                        {string.partyquoteG4}
                      </div>
                    </div>
                  </div>
                  <div className="text-right mt-auto pt-6 pb-4">
                    <div className="text-footerblue font-semibold text-sm md:text-base lg:text-lg xl:text-xl"></div>
                    <div className="text-footerblue text-sm pl-4 md:text-[0.875rem] lg:text-lg xl:text-xl">
                      <div
                        dangerouslySetInnerHTML={{ __html: string.partyroles6 }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-[35%] flex justify-center items-center">
                  <img
                    src={party10}
                    alt=""
                    className="w-auto h-auto max-w-full max-h-[400px] object-contain"
                  />
                </div>
              </div>
            </div>
          </Slider>
        </div>
        {/* major participate  */}
        <div className="px-4 py-12 overflow-hidden">
          <div className="relative font-EBGaramond flex justify-center my-10">
            <h2 className="uppercase text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-bold pb-[0.35rem]">
              {string.majorparty}
            </h2>
            <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
          </div>
          <div className="flex flex-col gap-12 overflow-x-hidden">
            <div className="hidden sm:grid gap-8 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 justify-between overflow-x-hidden">
              <div className="flex justify-center">
                <img src={party1} alt="" />
              </div>
              <div className="flex justify-center">
                <img src={party2} alt="" />
              </div>
              <div className="flex justify-center">
                <img src={party3} alt="" />
              </div>
              <div className="flex justify-center">
                <img src={party4} alt="" />
              </div>
              <div className="flex justify-center">
                <img src={party5} alt="" />
              </div>
              <div className="flex justify-center">
                <img src={party6} alt="" />
              </div>
            </div>
            <div className="relative major w-full block sm:hidden overflow-hidden">
              <Slider {...settings}>
                <div className="overflow-hidden">
                  <img src={party1} alt="" className="mx-auto" />
                </div>
                <div>
                  <img src={party2} alt="" className="mx-auto" />
                </div>
                <div>
                  <img src={party3} alt="" className="mx-auto" />
                </div>
                <div>
                  <img src={party4} alt="" className="mx-auto" />
                </div>
                <div>
                  <img src={party5} alt="" className="mx-auto" />
                </div>
                <div>
                  <img src={party6} alt="" className="mx-auto" />
                </div>
              </Slider>
            </div>
          </div>
        </div>
        {/* unique effective profitable  */}
        <div className="px-4 py-12">
          <div className="relative font-EBGaramond flex justify-center my-10">
            <h2 className="uppercase font-EBGaramond text-center text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-bold pb-[0.35rem]">
              {string.partyheading1}
            </h2>
            <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
          </div>
          <div className="flex flex-col gap-10 justify-between h-full">
            <div className="text w-full grid sm:grid-cols-2 justify-between md:px-28 gap-6 2xl:gap-8">
              <div className="flex gap-6 justify-center items-center">
                <div className="w-[15%]">
                  <img src={profit1} alt="" />
                </div>
                <p className="w-[80%] text-sm md:text-base lg:text-lg xl:text-xl">
                  {string.partyprofit1}
                </p>
              </div>
              <div className="flex gap-6 justify-center items-center">
                <div className="w-[15%]">
                  <img src={profit3} alt="" />
                </div>
                <p className="w-[80%] text-sm md:text-base lg:text-lg xl:text-xl">
                  {string.partyprofit3}
                </p>
              </div>
              <div className="flex gap-6 justify-center items-center">
                <div className="w-[15%]">
                  <img src={profit2} alt="" />
                </div>
                <p className="w-[80%] text-sm md:text-base lg:text-lg xl:text-xl">
                  {string.partyprofit2}
                </p>
              </div>
              <div className="flex gap-6 justify-center items-center">
                <div className="w-[15%]">
                  <img src={profit4} alt="" />
                </div>
                <p className="w-[80%] text-sm md:text-base lg:text-lg xl:text-xl">
                  {string.partyprofit4}
                </p>
              </div>
            </div>
            <div className="w-full">
              <div className=" grid lg:grid-cols-2 sm:grid-cols-1 gap-0 justify-center items-center">
                <img src={AboutImgs.A11} alt="" className="w-full " />
                <img
                  src={AboutImgs.A12}
                  alt="Blurred Car"
                  className="w-full "
                />
              </div>
            </div>
          </div>
        </div>
        {/* minutes  */}
        <div className="px-4 py-12">
          <div className="relative font-EBGaramond flex justify-center my-10">
            <h2 className="uppercase text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-bold pb-[0.35rem]">
              {string.partyheading2}
            </h2>
            <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 justify-between">
            <div className="flex flex-col gap-4">
              <div className="date bg-textblue py-4 text-white text-center text-sm md:text-base lg:text-lg xl:text-xl rounded-lg">
                {string.partyminutedate1}
              </div>
              <div className="w-full">
                <img
                  src={minute1}
                  alt=""
                  className="w-full h-40 object-contain rounded-lg"
                />
              </div>
              <ul className="list-disc pl-5 px-2 text-xs md:text-sm lg:text-base 2xl:text-lg space-y-1">
                <li>{string.partyminute1a}</li>
                <li>{string.partyminute1b}</li>
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <div className="date bg-textblue py-4 text-white text-center text-sm md:text-base lg:text-lg xl:text-xl rounded-lg">
                {string.partyminutedate2}
              </div>
              <div className="w-full">
                <img
                  src={minute2}
                  alt=""
                  className="w-full h-40 object-contain rounded-lg"
                />
              </div>
              <ul className="list-disc pl-5 px-2 text-xs md:text-sm lg:text-base 2xl:text-lg space-y-1">
                <li>{string.partyminute2}</li>
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <div className="date bg-textblue py-4 text-white text-center text-sm md:text-base lg:text-lg xl:text-xl rounded-lg">
                {string.partyminutedate3}
              </div>
              <div className="w-full">
                <img
                  src={minute3}
                  alt=""
                  className="w-full h-40 object-contain rounded-lg"
                />
              </div>
              <ul className="list-disc pl-5 px-2 text-xs md:text-sm lg:text-base 2xl:text-lg space-y-1">
                <li>{string.partyminute3}</li>
              </ul>
            </div>
            <div className="flex flex-col gap-4">
              <div className="date bg-textblue py-4 text-white text-center text-sm md:text-base lg:text-lg xl:text-xl rounded-lg">
                {string.partyminutedate4}
              </div>
              <div className="w-full">
                <img
                  src={AboutImgs.A7}
                  alt=""
                  className="w-full h-40 object-contain rounded-lg"
                />
              </div>
              <ul className="list-disc pl-5 px-2 text-xs md:text-sm lg:text-base 2xl:text-lg space-y-1">
                <li>{string.partyminute4}</li>
              </ul>
            </div>
          </div>
        </div>
        {/* who participate  */}
        <div ref={whoParticipateRef} id="whoparticipates" className="px-4">
          <div className="flex  gap-6 lg:gap-8 xl:gap-12">
            <div className="w-[50%]">
              <div className="relative font-EBGaramond flex justify-start my-8">
                <h2 className="uppercase text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-bold pb-[0.35rem]">
                  {string.who}
                </h2>
                <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
              </div>
              <div>
                <p className="font-light text-justify text-sm md:text-base lg:text-lg xl:text-xl leading-relaxed">
                  {string.whopara}
                </p>
              </div>
              {/* Registeration  */}
              <div className="flex justify-end">
                <button className="bg-gradient-to-r from-textblue to-footerblue p-1 px-2 xl:py-3 xl:px-5 rounded-full text-white text-sm md:text-base lg:text-lg xl:text-xl ">
                  <Link to="/register">Register</Link>
                </button>
              </div>
            </div>
            <div className="w-[50%]">
              <img src={AboutImgs.A13} alt="" className="w-full" />
            </div>
          </div>
        </div>
        {/* why participate  */}
        <div className="px-4 py-12">
          <CommonHome
            title={string.why}
            blue={string.whytitle}
            text={string.whypara}
            btn={string.whybtn}
            img={HWS2}
          />
          <div className="flex py-12 pt-20 gap-6 lg:gap-8 xl:gap-12">
            <div className="w-full md:w-[55%] lg:w-[50%] h-full">
              <div className="relative font-EBGaramond flex justify-start mb-4 xl:mb-8">
                <h2 className="uppercase text-lg sm:text-xl md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold pb-[0.35rem]">
                  {string.whopart}
                </h2>
                <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
              </div>
              <div className="pb-4 md:hidden image w-full md:w-[50%] h-full">
                <img src={common2} alt="" className="w-full rounded-lg" />
              </div>
              <div className="flex flex-col justify-between gap-6 xl:gap-8 items-start">
                <div className="text-sm md:text-[0.9rem] md:leading-5 lg:text-lg xl:text-[1.20rem] xl:leading-7 2xl:text-[1.25rem] 2xl:leading-8 text-justify font-light">
                  {string.whoparapart}
                </div>
                <div>
                  <button className="bg-gradient-to-r from-textblue to-footerblue py-2 px-4 xl:py-3 xl:px-6 rounded-full text-white text-sm md:text-base lg:text-lg xl:text-xl transition-all duration-300 hover:shadow-lg">
                    <Link onClick={handlePriceList}>{string.whybtn}</Link>
                  </button>
                </div>
              </div>
            </div>
            <div className="hidden md:block image w-[45%] lg:w-[50%] h-full">
              <img src={AboutImgs.A20} alt="" className="w-full rounded-lg" />
            </div>
          </div>
          <CommonHome
            title={string.official}
            img={AboutImgs.A10}
            blue={string.officialtitle}
            text={string.officialpara}
            btn={string.whybtn}
          />
        </div>
        {/* objective  */}
        <div id="objective" ref={objectiveRef} className="px-4 sm:px-8">
          <div className="relative font-EBGaramond flex justify-center ">
            <h2 className="uppercase text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold pb-[0.35rem]">
              {string.objkeyhead}
            </h2>
            <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
          </div>
          <div className="text-justify">
            <ul className="space-y-3">
              <div className="lg:pl-8 float-right pb-4">
                <img
                  src={AboutImgs.A14}
                  alt=""
                  className="object-contain max-w-[600px] w-full h-auto rounded-lg"
                />
              </div>
              {string.objkeyarray.map((index) => (
                <li
                  key={index}
                  className="text-base sm:text-lg md:text-xl lg:text-xl xl:text-2xl leading-relaxed"
                >
                  {index}
                </li>
              ))}
            </ul>
            <div className="flex justify-end">
              <button className="bg-gradient-to-r from-textblue to-footerblue p-1 px-2 xl:py-3 xl:px-5 rounded-full text-white text-sm md:text-base lg:text-lg xl:text-xl ">
                <Link to="/register">Register</Link>
              </button>
            </div>
          </div>
        </div>
        {/* SPONSPORS SECTION */}
        <div id="sponsor" ref={sponsorRef}>
          {Object.keys(string.categories).map((category) =>
            renderSponsorSection(category, string.categories[category]),
          )}
        </div>
      </div>
      <div className="container 3xl:w-[70%] px-4 lg:px-8 xl:px-12 2xl:px-20 py-8 text-right">
        <button>
          <img
            src={scroll}
            alt=""
            className="w-full transition-opacity duration-300"
            onClick={scrollToTop}
            style={{ display: visible ? "inline" : "none" }}
          />
        </button>
      </div>
    </section>
  );
};

export default Home;
